import { INSTALLMENT_BILLING, RECURRING_BILLING } from '../../constants';
import type { Deal, DealLine } from '../../types/domain';
import { eur } from '../format';
import { _estimatedMonthlyAmount, _lineEstimatedOneShot } from './estimatedRevenue';
import { activeLines } from './lines';

// Texte « Budget estimé » : total one-shot (forfait, échelonné compris) + mensuel estimé du
// récurrent — les mêmes montants que le potentiel (dealEstimatedRevenue), jamais le mensuel vendu.
export function dealBudgetText(a: Deal): string {
  const lignes = activeLines(a);
  const isRecurring = (l: DealLine) =>
    RECURRING_BILLING.includes(l.facturation as string) && l.facturation !== INSTALLMENT_BILLING;
  const parts: string[] = [];
  const oneShotTotal = lignes
    .filter((l) => !isRecurring(l))
    .reduce((s, l) => s + _lineEstimatedOneShot(l), 0);
  if (oneShotTotal > 0) parts.push(eur(oneShotTotal));
  const mensuel = lignes.filter(isRecurring).reduce((s, l) => s + _estimatedMonthlyAmount(l), 0);
  if (mensuel > 0) parts.push(`${eur(mensuel)}/mois`);
  return parts.length ? parts.join(' + ') : '—';
}
